<template>
  <div class="search-pane container-fluid" v-if="show" :class="{'fade-in' : shownClass, 'fade-out': !shownClass}" @click="hideSearch">
    <div class="row search-row">
      <div class="search-container col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">

        <div class="row">
          <div class="col-12 pl-1 pr-1 text-right">
            <button type="button" class="close" aria-label="Close" @click="hideSearch">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="card col-12" @click="(e) => {e.stopPropagation()}">
            <div class="card-body">

              <vue-bootstrap-typeahead
                v-model="query"
                :serializer="item => item.name"
                :data="items"
                :showOnFocus="true"
                :maxMatches="20"
                @hit="itemSelected"
                ref="searchInput"
                placeholder="Search Items..."
              >

                <!-- Begin custom suggestion slot -->
                <template slot="suggestion" slot-scope="{ data, htmlText }">
                  <div class="d-flex align-items-center">
                    <img loading="lazy" sizes="100%, 100%"
                      class=""
                      :src="iconSource(data)"
                      style="width: 40px; height: 40px;"/>

                    <span class="ml-4" v-html="htmlText"></span>
                    <!--                          <i class="ml-auto fab fa-github-square fa-2x"></i>-->
                  </div>
                </template>

              </vue-bootstrap-typeahead>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

  export default {
    name: "ItemSearch",
    components: {VueBootstrapTypeahead},
    props: {
      items: {
        type: Array,
      }
    },
    data() {
      return {
        shownClass: true,
        show: false,
        query: '',
      }
    },
    watch: {},
    methods: {
      iconSource: function (data) {
        if(data.icon === '') {
          return '/static/images/icons/equipment/none.png'
        }

        return `data:image/jpeg;base64,${data.icon}`
      },
      itemSelected: function (item) {
        this.$emit('selected', item);
        this.hideSearch();
      },
      focus: function () {
        this.$nextTick(() => this.$refs.searchInput.$refs.input.focus());
      },

      showSearch: function () {
        console.log('Showing Search');
        this.query = '';
        this.shownClass = true;
        this.show = true;
        this.focus()
      },

      hideSearch: function () {
        // console.log('Hiding Search');
        this.shownClass = false;

        //Allow 0.3s for animation to fade-out
        setTimeout(() => {
          this.show = false;
        }, 300);
      }
    },
  }
</script>

<style scoped>
  .search-pane {
    transition: 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .search-row {
    width: 100%;
  }

  .close {
    opacity: 0.8;
    font-size: 3rem;
  }

  .search-pane.shown {
    animation-direction: alternate;
    -webkit-animation-direction: alternate;
    -moz-animation-direction: alternate;
    -o-animation-direction: alternate;
  }

  .search-container {
    position: relative;
    z-index: 3;
    margin: 0 auto;
  }

  .fade-in {
    animation: fadeIn ease 0.3s;
    -webkit-animation: fadeIn ease 0.3s;
    -moz-animation: fadeIn ease 0.3s;
    -o-animation: fadeIn ease 0.3s;
  }

  .fade-out {
    animation: fadeOut ease 0.3s;
    -webkit-animation: fadeOut ease 0.3s;
    -moz-animation: fadeOut ease 0.3s;
    -o-animation: fadeOut ease 0.3s;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-o-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }


  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @-moz-keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @-webkit-keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @-o-keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/ItemSearch.vue